import React from 'react';
import { Box, FormHelperText, Typography } from '@mui/material';
import { FieldWrapperVertical } from '@ui-framework/index';
import ServiceProviderLocation from '@product-framework/components/FormFields/ServiceProviderLocation';

export default function AcceptanceLocationFormSection({
  showNoDefaultLocationMessage,
  showLocationField,
  formatMessage,
  errors,
}) {
  const error = errors?.acceptanceLocation;
  return (
    <>
      {showNoDefaultLocationMessage && (
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          {formatMessage({
            id: 'ACCEPT_JOB_NO_DEFAULT_LOCATION',
            defaultMessage:
              'No default location is set for your account. Please select a location to continue.',
          })}
        </Typography>
      )}
      {showLocationField && (
        <Box sx={{ mb: 2 }}>
          <FieldWrapperVertical
            field={{
              name: 'acceptanceLocation',
              label: {
                localeId: 'SERVICE_PROVIDER_LOCATION_LABEL',
                defaultMessage: 'Location',
              },
              required: true,
            }}
            errors={errors}>
            <ServiceProviderLocation
              field={{ name: 'acceptanceLocation' }}
              activeOnly
              isMulti={false}
              inPopUp
            />
            {error ? (
              <FormHelperText
                sx={{ typography: 'body2' }}
                error={Boolean(error)}>
                {error?.message}
              </FormHelperText>
            ) : null}
          </FieldWrapperVertical>
        </Box>
      )}
    </>
  );
}
